import Customer from '@/shared/types/customer.type';
import OrderCustomer from '@/shared/types/order/orderCustomer.type';

const transformCustomer = (customer: Customer): OrderCustomer[] => {
  return [
    {
      ...customer,
      billing_first_name: customer.first_name,
      billing_last_name: customer.last_name,
      billing_email_address: customer.email_address,
      billing_phone: customer.phone_number,
      delivery_first_name: customer.first_name,
      delivery_last_name: customer.last_name,
      delivery_email_address: customer.email_address,
      delivery_phone: customer.phone_number,
    },
  ];
};

export default transformCustomer;
